import * as React from "react";

import { cn } from "../lib/utils";

/**
 * Loading skeleton primitive. Renders a muted pulsing block sized via
 * className. Use to reserve space + signal "loading" before real content
 * paints (vs Loader2 spinners, which don't preserve layout).
 *
 *   <Skeleton className="h-4 w-24 rounded" />
 *   <Skeleton className="h-20 w-20 rounded-full" />
 */
const Skeleton = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn("animate-pulse rounded-md bg-white/[0.06]", className)}
      {...props}
    />
  )
);
Skeleton.displayName = "Skeleton";

export { Skeleton };
